<div class="search-container" [class]="customClass">
  <div class="search-input-wrapper">
    <svg
      class="search-icon"
      [class]="'icon-' + iconSize"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 17.5L12.5 12.5L17.5 17.5ZM14.1667 8.33333C14.1667 11.555 11.555 14.1667 8.33333 14.1667C5.11167 14.1667 2.5 11.555 2.5 8.33333C2.5 5.11167 5.11167 2.5 8.33333 2.5C11.555 2.5 14.1667 5.11167 14.1667 8.33333Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <input
      type="text"
      class="search-input"
      [attr.data-testid]="testId + '-input'"
      [placeholder]="placeholder"
      [ngModel]="searchTerm"
      (ngModelChange)="onInputChange($event)"
    />
    <svg
      *ngIf="searchTerm"
      class="close-icon"
      [attr.data-testid]="testId + '-clear-button'"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      (click)="onClearSearch()"
    >
      <path
        d="M15 5L5 15M5 5L15 15"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</div>
